import React from "react";
import { Close, Done } from "@mui/icons-material";

const styles = {
  enabled: {
    background: "#e2f1e2",
    color: "green",
  },
  disabled: {
    background: "#f4dede",
    color: "#c60505",
  },
};

const BooleanValue: React.FC<{ value: boolean }> = ({ value }) => {
  return !value ? (
    <Close style={styles.disabled} fontSize="small" />
  ) : (
    <Done style={styles.enabled} fontSize="small" />
  );
};

export default BooleanValue;
